module.exports = require('../_components/@alicd/next-grid/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/grid/index.js
// module id = 41
// module chunks = 0